import { render, staticRenderFns } from "./excellence.vue?vue&type=template&id=97f19b7c&scoped=true&"
import script from "./excellence.vue?vue&type=script&setup=true&lang=js&"
export * from "./excellence.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./excellence.vue?vue&type=style&index=0&id=97f19b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f19b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f19b7c')) {
      api.createRecord('97f19b7c', component.options)
    } else {
      api.reload('97f19b7c', component.options)
    }
    module.hot.accept("./excellence.vue?vue&type=template&id=97f19b7c&scoped=true&", function () {
      api.rerender('97f19b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/supplyChain/goods/components/excellence.vue"
export default component.exports